import { render, staticRenderFns } from "./BreadcrumbsComponent.vue?vue&type=template&id=090d03bd"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=090d03bd&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090d03bd')) {
      api.createRecord('090d03bd', component.options)
    } else {
      api.reload('090d03bd', component.options)
    }
    module.hot.accept("./BreadcrumbsComponent.vue?vue&type=template&id=090d03bd", function () {
      api.rerender('090d03bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BreadcrumbsComponent.vue"
export default component.exports